/**
 * Route-based promo code utility
 * Determines the appropriate promo code based on the current route
 */

import { PROMO_CODE } from "../config";

/**
 * Returns the appropriate promo code based on the current pathname
 * @param pathname - The current route pathname
 * @returns The promo code to use
 */
export const getRouteBasedPromoCode = (pathname: string): string => {
  // Root route uses NONSHOPPERPM
  if (pathname === '/') {
    return 'NONSHOPPERPM';
  }
  
  // Texas save route uses EIQPPC
  if (pathname === '/state/tx/save' || pathname === '/state/tx/save/' || pathname === 'state/tx/save') {
    return 'EIQPPC';
  }

  
  // For all other routes, use the default promo code from config
  return "NONSHOPPERPM";
};

/**
 * Hook-friendly version that gets the current pathname and returns the appropriate promo code
 * @param pathname - Current pathname from useLocation or window.location.pathname
 * @returns The promo code to use for the current route
 */
export const getCurrentPromoCode = (pathname?: string): string => {
  const currentPath = pathname || (typeof window !== 'undefined' ? window.location.pathname : '/');
  return getRouteBasedPromoCode(currentPath);
};
